//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/*import Vue from 'vue'
import YouTubeIframeLoader from 'youtube-iframe';*/
import YouTubePlayer from 'youtube-player';

export default {
    name: 'WatermarkingDemoVideo',
    data() {
        return {
            videoIds: {
                original: 'vJ5y5DDnYxQ',
                watermarked: 'NI7TSH-6z3M',
                camcord: 'FuHJXvEWrCs',
                crop: '7Bgss0fyQgc',
                compression: 'ewyZKIxD_Ls',
                partial: 'DD_ACqh8aH0',
                color: 'vUwctDOJOfg',
                sound: 'uI5I2qtW4m8',
                all: '82J5p8RIBa8'

            },
            step: 2,
            playing: false,
            video: 'camcord',
            p1: null,
            p2: null,
            YT: null,
            tooltip: false,
        }
    },
    computed: {
        titlePart() {
            return {
                2: 'Test the resilience of our technology',
                3: 'Test the resilience of our technology'
            }[this.step]
        },
        iframeLink() {
            return {
                'camcord': 'https://www.youtube.com/embed/FuHJXvEWrCs',
                'crop': 'https://www.youtube.com/embed/7Bgss0fyQgc',
                'compression': 'https://www.youtube.com/embed/ewyZKIxD_Ls',
                'partial': 'https://www.youtube.com/embed/DD_ACqh8aH0',
                'color': 'https://www.youtube.com/embed/vUwctDOJOfg',
                'sound': 'https://www.youtube.com/embed/uI5I2qtW4m8',
                'all': 'https://www.youtube.com/embed/82J5p8RIBa8',
            }[this.video]
        }
    },
    mounted() {
        this.p1 = YouTubePlayer('original')
        this.p1.loadVideoById(this.videoIds.watermarked)
        this.p1.stopVideo();

        this.p2 = YouTubePlayer('watermarked')
        this.p2.loadVideoById(this.videoIds.original)
        this.p2.stopVideo();

        this.p3 = YouTubePlayer('modified')
        this.p3.loadVideoById(this.videoIds.camcord)
        this.p3.stopVideo();
    },
    methods: {
        play() {
            let p1 = this.p1;
            let p2 = this.p2;
            if (this.step === 3) {
                p1 = this.p2;
                p2 = this.p3
            }
            this.playing = true
            p1.playVideo();
            p2.playVideo();
            p1.addEventListener('onStateChange', (event) => {
                if (event.data === YT.PlayerState.PLAYING && !this.playing) {
                    if (p2.getPlayerState() !== 1) {
                        p1.seekTo(0);
                        p1.pauseVideo()
                        p1.playVideo()
                    } else {
                        this.playing = true;
                        p1.seekTo(0);
                        p2.seekTo(0);
                    }
                }
            })
        },
        stop() {
            this.playing = false
            this.p1.pauseVideo();
            this.p2.pauseVideo();
            this.p3.pauseVideo();
            this.rewind()
        },
        rewind() {
            this.p1.seekTo(0);
            this.p2.seekTo(0);
            this.p3.seekTo(0);
        },
        toggleTooltip() {
            if (this.tooltip) {
                document.querySelector('.dropdown-container').style.height = "0px"
            } else {
                const {height} = document.querySelector('.dropdown').getBoundingClientRect()
                document.querySelector('.dropdown-container').style.height = height + "px"
            }
            this.tooltip = !this.tooltip
        },
        changeVideo(type) {
            this.video = type;
            this.toggleTooltip();
            this.stop();
            this.p3.destroy()
            this.p3 = YouTubePlayer('modified')
            this.p3.loadVideoById(this.videoIds[type])
            this.p3.stopVideo().then(() => {
                this.rewind()
                this.play()
            });
        },
        nextStep() {
            this.rewind()
            this.stop()
            this.step += 1;
            const step = document.querySelector('.step');
            const steps = document.querySelector('.steps')
            const {width} = step.getBoundingClientRect()
            steps.style.transform = `translateX(-${(this.step - 2) * width}px)`

        },
        previousStep() {
            this.rewind();
            this.stop()
            this.step -= 1;
            const step = document.querySelector('.step');
            const steps = document.querySelector('.steps')
            const {width} = step.getBoundingClientRect()
            steps.style.transform = `translateX(-${(this.step - 2) * width}px)`
        }
    }
}




// WEBPACK FOOTER //
// ./scripts/demo/WatermarkingDemoVideo.vue